import { css, Global } from '@emotion/react'
import { Breadcrumbs, Stack, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'

import Content from 'components/common/Content'
import Icon from 'components/Icon'
import Header from 'components/navigation/Header'
import { CompanyDashboardContainer } from 'components/reliability-management/company-dashboard/CompanyDashboardContainer'
import theme from 'theme'

const CompanyDashboardPage: React.FC = () => {
  return (
    <>
      <Helmet title="Dashboard" />
      {/* Set global styles for printing the Company Dashboard Report */}
      <Global
        styles={css`
          @media print {
            #CompanyDashboardListControls,
            #CompanyDashboardListSectionPagination,
            #CompanyDashboardReportExportButton,
            #CompanyDashboardServiceListTitle,
            #FooterLinks,
            #NavDrawer,
            #ToastContainerSnackbar {
              display: none;
            }
            #CompanyDashboardReportGremlinLogo {
              display: flex;
            }
            #CompanyDashboardReportServiceListTitle {
              display: block;
            }
            #Footer {
              position: fixed;
              bottom: 0px;
              padding: 0px;
              border-top: none;
            }
            #PrintPageBreak {
              break-before: avoid;
              break-after: page;
            }
            // Sizes the page to fit the desired breakpoints, component spacing, and component sizing
            @page {
              size: 330mm 427mm;
            }
          }
        `}
      />
      <Header css={{ '@media print': { display: 'none' } }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Stack alignItems="center" direction="row">
            <Icon css={{ marginRight: theme.space[2] }} icon="chartLineUp" />{' '}
            <Typography color="text.primary">Dashboard</Typography>
          </Stack>
        </Breadcrumbs>
      </Header>
      <Content
        css={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr)',
          gridAutoRows: 'min-content',
          gap: theme.space[6]
        }}
      >
        <CompanyDashboardContainer />
      </Content>
    </>
  )
}

export default CompanyDashboardPage
